import { 
  Hash, 
  Wand2, 
  Star, 
  Heart, 
  BookOpen, 
  MoreHorizontal,
  Sparkles,
  Eye,
  Flower,
  Brain,
  Gem,
  Palette
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

// Mapeamento de categorias para ícones
export const categoryIconMap: Record<string, LucideIcon> = {
  "numerologia": Hash,
  "tarô": Wand2,
  "tarot": Wand2,
  "astrologia": Star,
  "terapias": Heart,
  "terapia": Heart,
  "cursos": BookOpen,
  "curso": BookOpen,
  "cristaloterapia": Gem,
  "cristais": Gem,
  "reiki": Sparkles,
  "quiromancia": Eye,
  "florais": Flower,
  "pnl": Brain,
  "arte": Palette,
  "pintura": Palette,
};

export function getCategoryIcon(categoryName: string): LucideIcon {
  const normalizedName = categoryName.toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, ""); // Remove acentos
  
  // Busca por palavras-chave no nome da categoria
  for (const [key, icon] of Object.entries(categoryIconMap)) {
    if (normalizedName.includes(key)) {
      return icon;
    }
  }
  
  // Ícone padrão se não encontrar correspondência
  return MoreHorizontal;
}